export const companyPolicyConstants = {
    COMPANY_FETCHING: 'COMPANY_FETCHING',
    COMPANY_FETCHED: 'COMPANY_FETCHED',
    COMPANY_SUBMITING: 'COMPANY_SUBMITING',
    COMPANY_SUBMITED: 'COMPANY_SUBMITED',
    GET_ALL_COMPANY_POLICIES: 'GET_ALL_COMPANY_POLICIES',
    GET_COMPANY_POLICIES: 'GET_COMPANY_POLICIES',
    GET_COMPANY_POLICY_BY_ID: 'GET_COMPANY_POLICY_BY_ID',
    UPDATE_COMPANY_POLICY: 'UPDATE_COMPANY_POLICY',
    SEARCH_COMPANY_POLICIES: 'SEARCH_COMPANY_POLICIES'
}